export type AppEnv = 'dev' | 'staging' | 'production';

export function getAppEnv(): AppEnv | undefined {
  const value = import.meta.env.VITE_APP_ENV;
  if (value === 'dev' || value === 'staging' || value === 'production') {
    return value;
  }
  return undefined;
}
